<template>
    <div>
        <div class="loading-spinner" v-if="!itemlists">
            <base-spinner></base-spinner>
        </div>
        <!--검색 조건 -->

        <!-- 항목 테이블 -->
        <div class="tbl_wrap" v-if="itemlists">
            <div class="search_part">
                <button @click="getBuyItems()">새로고침</button>
            </div>
            <table class="tbl">
                <colgroup>
                    <col style="width:5%" />
                    <col style="*" />
                    <col style="width:15%" />
                    <col style="width:10%" />
                    <col style="width:10%" />
                    <col style="width:10%" />
                    <col style="width:10%" />
                    <col style="width:10%" />
                </colgroup>
                <thead>
                    <tr>
                        <th>번호</th>
                        <th>아이템</th>
                        <th>가격</th>
                        <th>구매수량</th>
                        <th>사용가능수</th>
                        <th>구매날짜</th>
                        <th>상태</th>
                        <th>환불신청</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="itembuylists.data.length ===0">
                        <tr><td colspan="8">구매한 아이템이 없습니다.</td></tr>
                    </template>
                    <template v-else>
                        <tr v-for="(item, index) in itembuylists.data" :key="index" :class="{'isUseable':item.remain>0}">
                            <td>{{itembuylists.total - itembuylists.from + 1 - index}}</td>
                            <td>{{item.item_title}}</td>
                            <td>
                                <template v-if="item.item_price > 0">
                                    {{addComma(item.item_price)+' 원'}}
                                </template>
                                <template v-else>
                                    {{addComma(Math.abs(item.item_point))+' P'}}
                                </template>
                            </td>
                            <td>{{item.count}}</td>
                            <td>
                                <span class="remain"> {{item.remain}} </span>
                            </td>
                            <td><display-time :time="item.created_at"/></td>
                            <td :class="{'isActive':item.state===1}">
                                <div class="btn_use" v-if="item.state===1 && item.remain > 0">
                                    <base-button-sm mode="orange" @click="popUse(item.id)">사용하기</base-button-sm>
                                </div>
                                <span v-else>
                                    {{itemState[item.state]}}
                                </span>
                            </td>
                            <td>
                                <div class="btn_use" v-if="item.count === item.remain && item.item_price> 0 && item.state==1 ">
                                    <base-button-sm  @click="refund(item.id)">환불신청</base-button-sm>
                                </div>
                            </td>
                        </tr>
                    </template>

                </tbody>
            </table>
            <paginate store="item" collection="itemBuy"  @paging="getBuyItems" :isMobile="true"/>
        </div>
        <!-- 항목 테이블 -->
        <pop-item :show="ckItemUse" @close="confirm" :itemId="currentItemId" :selcomp="selcomponent">
            <template v-slot:header>
               <div>{{poptitle}}</div>
            </template>
        </pop-item>
    </div>
</template>
<script>
import { myItemBuy } from '@/components/mixins/pages/myItemBuy.js'
export default {
    name:'myItemBuy',
    mixins:[ myItemBuy ],
    data(){
        return{         
        }
    },
    
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/table';
.isUseable{
     cursor:pointer;
    td{color:black !important;}
    .remain{background:#0d4e7c;border-radius:5px; padding:5px 10px;color:white;font-weight:bold}
    .isActive{
        span{color:red;font-weight:bold}
    }
}
.btn_use{line-height:20px;
    button{margin:0}
}

</style>
